<template>
  <div class="home-amap">
    <div id="container" class="amap" ref="map-container"></div>
  </div>
</template>

<script>
import { getParkDistribute } from '@/api/api';
// import AMapLoader from "@amap/amap-jsapi-loader";
import config from '@/config/index';
import { bd_encrypt, bd_decrypt } from '@/libs/tools';
export default {
  name: 'homeAmap',
  data() {
    return {
      map: null,
      timer: null,
      mapSize: 14,
      userLocation: {
        lng: 118.915804,
        lat: 25.120399,
        radius: 3,
      }, // 用户所在位置
    };
  },
  mounted() {
    // this.initMap();
  },
  methods: {
    // 初始化地图
    // initMap() {
    //     if (this.$Amap) {
    //         this.map = new this.$Amap.Map("container", {
    //             zoom: this.mapSize, //级别
    //             resizeEnable: true,
    //             center: new AMap.LngLat(this.userLocation.lng + "", this.userLocation.lat + ""),
    //         });
    //         this.setPosition();
    //         clearInterval(this.timer);
    //     } else {
    //         this.timer = setInterval(this.initMap, 1000);
    //     }
    // },
    // initMap() {
    //     let that = this;
    //     AMapLoader.load({
    //         key: config.AMAP_KEY, // key
    //         plugins: ["AMap.Geocoder", "AMap.Geolocation", "AMap.AutoComplete"], // 插件
    //     })
    //         .then((Amap, b) => {
    //             this.$Amap = Amap;
    //             that.map = new Amap.Map("container", {
    //                 zoom: that.mapSize, // 级别
    //                 resizeEnable: true,
    //                 center: new AMap.LngLat(this.userLocation.lng + "", this.userLocation.lat + ""),
    //             });
    //             that.map.on('complete', function () {
    //                 // 地图图块加载完成后触发
    //                 that.setPosition();
    //             });
    //         })
    //         .catch((err) => {
    //             throw new Error("加载高德地图失败：" + err);
    //         });
    // },
    // 设置定位
    setPosition() {
      if (!this.map) return;
      let that = this;
      this.map.clearMap();
      let options = {
        showButton: false, // 是否显示定位按钮
        // 'buttonPosition': 'LB',//定位按钮的位置
        /* LT LB RT RB */
        // 'buttonOffset': new AMap.Pixel(10, 20),//定位按钮距离对应角落的距离
        showMarker: true, // 是否显示定位点
        showCircle: false, // 是否显示定位精度圈
      };

      this.map.plugin(['AMap.Geolocation'], function () {
        let geolocation = new that.$Amap.Geolocation(options);
        that.map.addControl(geolocation);
        geolocation.getCurrentPosition(function (status, result) {
          if (status == 'complete') {
            console.log(result);

            that.$store.commit('setLocation', result.position); // 将当前location存起来
            that.userLocation.lng = result.position.lng;
            that.userLocation.lat = result.position.lat;
            that.setPositionWithPoint(result.position);
          } else {
            // 失败提供默认
            let address = {
              position: {
                lng: 118.915804,
                lat: 25.120399,
              },
            };
            that.setPositionWithPoint(address.position);
            that.$toast('定位获取失败');
          }
        });
      });
    },
    // 添加半径范围、当前位置
    setPositionWithPoint(p) {
      if (!this.map) return;
      let that = this;
      let myPosition = new AMap.Marker({
        map: that.map,
        offset: new AMap.Pixel(-7, -28),
        content: '<div class="location-point"></div>',
        position: new AMap.LngLat(p.lng + '', p.lat + ''),
      });
      // 半径圆
      let circle = new AMap.Circle({
        map: that.map,
        radius: that.userLocation.radius * 1000,
        strokeColor: '#0093FF',
        noSelect: true,
        strokeOpacity: 0.5,
        strokeWeight: 1,
        fillColor: '#02B0FF',
        fillOpacity: 0.25,
        center: new AMap.LngLat(p.lng + '', p.lat + ''),
      });

      this.getParking(p);

      setTimeout(() => {
        this.map.setZoomAndCenter(this.mapSize, [p.lng, p.lat]);
      }, 1);
    },
    // 获取停车场
    getParking(point) {
      let that = this;
      let obj = {
        lat: point.lat,
        lng: point.lng,
        radius: this.userLocation.radius,
      };

      getParkDistribute(obj).then((res) => {
        if (res.code == 200) {
          that.parkingLotList = res.data.rows;
          that.parkingList = res.data.rows;
          let points = res.data.rows;

          if (points.length > 0) {
            // 判断当前是有选择某个车场
            let obj = that.$route.params;
            if (Object.keys(obj).length > 0) {
              that.showParkingLotDetail = true;
              that.detailData = obj;
            }
            that.showParkingLot = true; // 弹出底部车场
            that.addPointToMap(points);
          }
        }
      });
    },

    // 添加地图点到地图中
    addPointToMap(points) {
      let that = this;
      let roadNum = 0;
      let parkNum = 0;
      let markers = [];
      for (let i = 0; i < points.length; i++) {
        // 区分开路内停车和路外停车
        if (points[i].type == 1) roadNum++;
        else if (points[i].type == 2) parkNum++;

        let rate =
          (points[i].restStall || 0) /
          (points[i].totalStall && points[i].totalStall > 0
            ? points[i].totalStall
            : 1);
        let type = 'red';
        if (rate > 0.6) {
          type = 'green';
        } else if (rate > 0.3) {
          type = 'orange';
        }

        let gd_point = bd_decrypt(points[i].lng, points[i].lat);

        let marker = new AMap.Marker({
          position: [gd_point.lng, gd_point.lat],
          // content: `<div style="border:1px red solid;width: 80px;height: 43.5px;"></div>`,

          content: `<div style=""  class="amap-marker-content-${type}">
                        <p class="parkinglot-name-${type}">${points[i].parkName}</p>
                        <p class="parkinglot-num-${type}">${points[i].restStall}</p>
                    </div>`,
          title: points[i].name,
          clickable: true,
          // anchor: "center",
          offset: new AMap.Pixel(-40, -43.5),

          // anchor: "bottom-left",
        });

        marker.on('click', function (e) {
          that.toParkingDetail(points[i]);
        });
        if (this.map) {
          this.map.add(marker);
        }
        marker['ids'] = i;
        that.parkingLotList[i]['ids'] = i;

        markers.push(marker);
      }
      if (this.map) {
        this.setMarkerClusterer(this.map, markers);
      }
      this.roadNum = roadNum;
      this.parkNum = parkNum;
    },
    setMarkerClusterer(map, markers) {
      let that = this;
      let count = markers.length;

      const _renderClusterMarker = function (context) {
        let markers = context.markers;
        var stallCodeNum = 0;
        let stallCodeAreaData = [];
        for (let i = 0; i < markers.length; i++) {
          for (let j = 0; j < that.parkingLotList.length; j++) {
            if (markers[i].ids == that.parkingLotList[j].ids) {
              stallCodeAreaData.push(that.parkingLotList[j]);
              stallCodeNum += that.parkingLotList[j].restStall * 1;
            }
          }
        }
        for (let i = 0; i < stallCodeAreaData.length; i++) {
          if (i > 0) {
            if (
              stallCodeAreaData[i].lat == stallCodeAreaData[i - 1].lat &&
              stallCodeAreaData[i].lng == stallCodeAreaData[i - 1].lng
            ) {
            }
          }
        }

        context.marker.setOffset(new AMap.Pixel(-32.5, -74.5));
        // context.marker.setAnchor("bottom-center");

        context.marker.setContent(`
                     <div class="amap-marker-content-road">
                        <p class="parkinglot-name-road">停车场</p>
                         <p class="parkinglot-num-road">${stallCodeNum}</p>
                     </div>
                    `);
      };

      AMap.plugin(['AMap.MarkerClusterer'], function () {
        let cluster = new AMap.MarkerClusterer(map, markers, {
          // styles: sts,
          gridSize: 80,
          renderClusterMarker: _renderClusterMarker,
        });
      });
    },
    // 跳转到车场详情
    toParkingDetail(item) {
      // 用于区分是停车场还是地点
      item.type = 'parking';
      this.$router.push({ name: 'Parking', params: item });
    },
  },
  beforeDestroy() {
    if (this.map) {
      this.map.destroy();
    }
  },
};
</script>

<style lang="less" scoped>
.home-amap {
  width: 702px;
  height: 562px;
  margin-top: 40px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .amap {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }

  .amap-marker-content {
    color: #fff;
  }
}
</style>
<style lang="less">
.amap-marker-content-green {
  width: 160px;
  height: 87px;
  color: #fff;
  background: url('~@/assets/images/home/parking-green.png') no-repeat;
  background-size: 100% 100%;
  font-size: 20px;
  color: #41cf8a;

  .parkinglot-name-green {
    width: 135px;
    text-align: center;
    margin: 0 auto;
    padding-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .parkinglot-num-green {
    text-align: center;
    margin: 0 auto;
  }
}

.amap-marker-content-red {
  width: 160px;
  height: 87px;
  color: #fff;
  background: url('~@/assets/images/home/parking-red.png') no-repeat;
  background-size: 100% 100%;
  font-size: 20px;
  color: #f72d2d;

  .parkinglot-name-red {
    width: 135px;
    text-align: center;
    margin: 0 auto;
    padding-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .parkinglot-num-red {
    text-align: center;
    margin: 0 auto;
  }
}

.amap-marker-content-orange {
  width: 160px;
  height: 87px;
  color: #fff;
  background: url('~@/assets/images/home/parking-orange.png') no-repeat;
  background-size: 100% 100%;
  font-size: 20px;
  color: #f76a2d;

  .parkinglot-name-orange {
    width: 135px;
    text-align: center;
    margin: 0 auto;
    padding-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .parkinglot-num-orange {
    text-align: center;
    margin: 0 auto;
  }
}

.amap-marker-content-road {
  width: 130px;
  height: 149px;
  color: #fff;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  padding-top: 30px;
  align-items: center;
  background: url('~@/assets/images/home/parking-road.png') no-repeat;
  background-size: 100% 100%;
  font-size: 26px;
  color: #ffffff;

  .parkinglot-name-road {
    width: 135px;
    text-align: center;
    margin: 0 auto;
    padding-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .parkinglot-num-road {
    text-align: center;
    margin: 0 auto;
  }
}
</style>
